import React, { useEffect, useState } from 'react'
import { hashHistory } from 'react-router';
import { useStyle } from "./Style";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material';
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import DialpadIcon from '@mui/icons-material/Dialpad';
import CelebrationOutlinedIcon from '@mui/icons-material/CelebrationOutlined';
import PhoneIphoneOutlinedIcon from '@mui/icons-material/PhoneIphoneOutlined';
import { getPartnerGuid, getUserEmail, getUserFullname, hasAuthourity } from '../../../lib/access.es6';
import { getPartnerConfigs } from '../../../lib/requests.es6';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import posthog from 'posthog-js';
import FloatingSimulator from '../../OldMutualMalawi/UssdSessions/Components/FloatingSimulator/FloatingSimulator';
import { USSDSTART_FLOW_REF } from '../../OldMutualMalawi/UssdSessions/constants';
import { isOmkAgent } from '../../OldMutualKenya/shared/agentView';

const HomePageCta = (props) => {
  const classes = useStyle();

  // Agents sell; they do not administer. Claims and reports are neither theirs
  // nor scoped to them, so an agent keeps "Get a policy" only.
  const isAgentView = isOmkAgent();

  // Generic across any partner - mailroom resolves the org by uuid (ussd_org_uuid on this partner's
  // config) rather than a hardcoded partner map, so any partner with ussd_business_features_active set
  // gets this card automatically. Gated on SIMULATE_USSD_FLOW, not VIEW_USSD_SESSIONS - this card calls
  // mailroom's /business/simulate/start, which requires that role specifically.
  const [ussdBusinessFeaturesActive, setUssdBusinessFeaturesActive] = useState(false);
  useEffect(() => {
    getPartnerConfigs()
      .then(response => setUssdBusinessFeaturesActive(!!response.data.ussd_business_features_active))
      .catch(() => setUssdBusinessFeaturesActive(false));
  }, []);

  const showGetPolicyViaUssd =
    ussdBusinessFeaturesActive &&
    hasAuthourity('SIMULATE_USSD_FLOW') &&
    !isAgentView;

  const [ussdPromptOpen, setUssdPromptOpen] = useState(false);
  const [ussdMsisdnInput, setUssdMsisdnInput] = useState('');
  const [ussdMsisdn, setUssdMsisdn] = useState('');

  const startUssdPurchase = () => {
    const cleaned = ussdMsisdnInput.replace(/[^0-9]/g, '');
    setUssdMsisdn(cleaned);
    setUssdPromptOpen(false);
  }

  const handleRegisterCustomer = () => {
    
    hashHistory.push('admin/generate-policy');
    posthog.capture('clicked_get_a_policy_homepage', {
      email: `${getUserEmail()}`,
      name: `${getUserFullname()}`,
      partner: `${getPartnerGuid()}`,
      timestamp: new Date().toLocaleString(),
  });
  
  }
  const viewClaims = () => {
    hashHistory.push('admin/claims_dashboard');
  }

  const viewReports = () => {
    hashHistory.push('admin/reports');
  }


  return (
    <>
      <section className={classes.welcomewrapper}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <div className={classes.welcomeheading}>
              <span> {props.labels.hello} {getUserFullname()} {props.labels.welcomeBack} !</span>
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} sm={3}>
            <div className={classes.boxoptionwrapper} onClick={handleRegisterCustomer}>
              <ul>
                <li><HowToRegOutlinedIcon /></li>
                <li>Get a policy </li>
              </ul>
            </div>
          </Grid>
          {!isAgentView && (
            <Grid item xs={12} md={3} sm={3}>
              <div className={classes.boxoptionwrapper} onClick={viewClaims}>
                <ul>
                  <li><InventoryOutlinedIcon /></li>
                  <li>{props.labels.viewClaims}</li>
                </ul>
              </div>
            </Grid>
          )}
          {!isAgentView && (
            <Grid item xs={12} md={3} sm={3}>
              <div className={classes.boxoptionwrapper} onClick={viewReports}>
                <ul>
                  <li><AssignmentIndOutlinedIcon /></li>
                  <li>{props.labels.viewReports}</li>
                </ul>
              </div>
            </Grid>
          )}
          {showGetPolicyViaUssd && (
            <Grid item xs={12} md={3} sm={3}>
              <div className={classes.boxoptionwrapper} onClick={() => setUssdPromptOpen(true)}>
                <ul>
                  <li><DialpadIcon /></li>
                  <li>Simulate USSD Purchase</li>
                </ul>
              </div>
            </Grid>
          )}
        </Grid>
      </section>

      <Dialog open={ussdPromptOpen} onClose={() => setUssdPromptOpen(false)}>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <DialpadIcon color="primary" />
          Simulate USSD Purchase
        </DialogTitle>
        <DialogContent>
          <Alert severity="success" icon={<CelebrationOutlinedIcon />} sx={{ marginBottom: 2 }}>
            It's the real deal - experience it as your customer would.
          </Alert>
          <TextField
            autoFocus
            label="Customer phone number"
            placeholder="265991361790"
            helperText="Include the country code, no leading + or 0"
            InputProps={{
              startAdornment: <PhoneIphoneOutlinedIcon sx={{ marginRight: 1, color: 'text.secondary' }} />
            }}
            value={ussdMsisdnInput}
            onChange={(e) => setUssdMsisdnInput(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && startUssdPurchase()}
            fullWidth
            margin="dense"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setUssdPromptOpen(false)}>Cancel</Button>
          <Button variant="contained" startIcon={<DialpadIcon />} onClick={startUssdPurchase}>
            Start
          </Button>
        </DialogActions>
      </Dialog>

      {ussdMsisdn && (
        <FloatingSimulator flowUuid={USSDSTART_FLOW_REF} msisdn={ussdMsisdn} autoOpen />
      )}
      <section className={classes.citybg}></section>
    </>
  )
}

export default HomePageCta